import { send_request } from './Request';

/**
 * Fetches usage information from the backend
 * @returns {Promise<Object>} Usage data matching UsageInfoDto structure
 */
export const fetchUsageData = async () => {
  try {
    const response = await send_request('authz-service/organization/get-usage-info', '', '', 'GET');

    if (response && response.status === 200 && response.data) {
      return {
        success: true,
        data: response.data,
      };
    } else {
      console.error('Failed to fetch usage data:', response);
      return {
        success: false,
        error: 'Failed to fetch usage data',
        data: null,
      };
    }
  } catch (error) {
    console.error('Error fetching usage data:', error);
    return {
      success: false,
      error: error.message || 'Unknown error occurred',
      data: null,
    };
  }
};

/**
 * Usage data structure type definition for reference:
 * {
 *   totalActions: number,
 *   usedActions: number,
 *   remainingActions: number,
 *   totalAiCredits: number,
 *   usedAiCredits: number,
 *   remainingAiCredits: number,
 *   seats: number,
 *   maxWorkflows: number, // -1 for unlimited
 *   maxComponents: number,
 *   fileStorageGb: number,
 *   fileStorageMb: number
 * }
 */
